import React from 'react';
import { Box, Typography } from '@mui/material';
import { keyframes } from '@mui/system';

// 呼吸燈動畫
const breathe = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.6; }
`;

interface OnAirIndicatorProps {
  isOnAir: boolean;
  onClick: () => void;
  participantCount?: number;
}

const OnAirIndicator: React.FC<OnAirIndicatorProps> = ({ 
  isOnAir, 
  onClick,
  participantCount = 0
}) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        position: 'fixed',
        top: 80,
        right: 16,
        zIndex: 1300,
        backgroundColor: isOnAir ? '#d32f2f' : '#ffffff',
        color: isOnAir ? '#ffffff' : '#1976d2',
        borderRadius: '20px',
        padding: '6px 16px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        boxShadow: isOnAir 
          ? '0 4px 12px rgba(211, 47, 47, 0.4)' 
          : '0 2px 8px rgba(0, 0, 0, 0.15)',
        border: isOnAir ? 'none' : '2px solid #1976d2',
        transition: 'all 0.3s ease',
        animation: isOnAir ? `${breathe} 2s ease-in-out infinite` : 'none',
        '&:hover': {
          transform: 'scale(1.05)',
          boxShadow: isOnAir 
            ? '0 6px 16px rgba(211, 47, 47, 0.5)' 
            : '0 4px 12px rgba(25, 118, 210, 0.3)',
        }
      }}
    >
      {/* 紅點指示器（只在 OnAir 時顯示） */}
      {isOnAir && (
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: '#ffffff',
            animation: `${breathe} 1s ease-in-out infinite`,
          }}
        />
      )}
      
      {/* OnAir 文字 */}
      <Typography
        variant="body2"
        sx={{
          fontWeight: 'bold',
          fontSize: '0.875rem',
          letterSpacing: '0.5px',
        }}
      >
        {isOnAir ? 'ON AIR' : 'OFFLINE'}
      </Typography>

      {/* 參與者數量（只在 OnAir 且有參與者時顯示） */}
      {isOnAir && participantCount > 0 && (
        <Box
          sx={{
            backgroundColor: 'rgba(255, 255, 255, 0.3)',
            borderRadius: '10px',
            padding: '2px 8px',
            fontSize: '0.75rem',
            fontWeight: 'bold',
          }}
        >
          {participantCount}
        </Box>
      )}
    </Box>
  );
};

export default OnAirIndicator;

